var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evn-domains"},_vm._l((_vm.list),function(item,index){return _c('el-tag',{key:index,staticClass:"x-overflow-hidden",attrs:{"type":"info","size":"mini"}},[_vm._v(_vm._s(_vm.$opt.switchStr(item, _vm.$opt.env)))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }